module.exports = __webpack_public_path__ + "media/images/weather/156_night-f03dfd7f0cecb0f6381053ae1ee93a98.png";